import React from 'react';
import { throttle } from 'lodash';
import styled from 'styled-components';
import { sizes } from 'styles/media';

const Wrapper = styled.div`
  position: fixed;
  top: 5px;
  right: 5px;
  font-size: 12px;
  z-index: 5000;
`;

export default class BreakpointDisplay extends React.Component {
  constructor(props) {
    super(props);
    this.throttledCheckBreakpoint = throttle(this.checkBreakpoint, 500);
  }

  state = { breakpoint: 'mobile' };

  componentDidMount() {
    this.checkBreakpoint();
    window.addEventListener('resize', this.throttledCheckBreakpoint);
  }

  checkBreakpoint = () => {
    const width = window.innerWidth;
    const breakpoint = Object.keys(sizes).find(bp => width >= sizes[bp]);
    this.setState({ breakpoint: breakpoint || 'mobile' });
  };

  render() {
    return <Wrapper>{this.state.breakpoint}</Wrapper>;
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/BreakpointDisplay/BreakpointDisplay.js